"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeByName = exports.THEMES = exports.DEFAULT_THEME = exports.AVAILABLE_THEMES = void 0;
var _themeAllium = _interopRequireDefault(require("@telus-uds/theme-allium"));
var _themeKoodo = _interopRequireDefault(require("@telus-uds/theme-koodo"));
var _themePublicMobile = _interopRequireDefault(require("@telus-uds/theme-public-mobile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var THEMES = exports.THEMES = {
  ALLIUM: 'Allium',
  KOODO: 'Koodo',
  PUBLIC: 'Public'
};
var DEFAULT_THEME = exports.DEFAULT_THEME = THEMES.ALLIUM;
var AVAILABLE_THEMES = exports.AVAILABLE_THEMES = Object.values(THEMES);
var THEME_IMPORTS = {
  [THEMES.ALLIUM]: _themeAllium.default,
  [THEMES.KOODO]: _themeKoodo.default,
  [THEMES.PUBLIC]: _themePublicMobile.default
};
var defaultTheme = THEME_IMPORTS[THEMES.ALLIUM];
var getThemeByName = themeName => {
  var _THEME_IMPORTS$themeN;
  return (_THEME_IMPORTS$themeN = THEME_IMPORTS[themeName]) !== null && _THEME_IMPORTS$themeN !== void 0 ? _THEME_IMPORTS$themeN : defaultTheme;
};
exports.getThemeByName = getThemeByName;